<div  class="sidenav zIndex" [style.width]="menuWidth" >
  <a href="javascript:void(0)"  class="closebtn" (click)="hide()">&times;</a>
  <ng-content></ng-content>
</div>